import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TravelSummary from './TravelSummary';
import { tripSummaryContainer } from '../styles';

const TravelSummaryContainer: FC = () => {
  const { t: tt } = useTranslation('WEB');

  return (
    <div css={tripSummaryContainer}>
      <TravelSummary heading={tt('Travel Summary')} />
    </div>
  );
};

export default TravelSummaryContainer;
